import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "types/store";
import { Button } from "aible";
import Tooltip from "components/Inputs/Tooltip";
import LabeledToggle from "components/Inputs/Toggle/Toggle";
import * as homeReducer from "containers/Home/reducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import { isEnabled } from "utils/featureFlags";
import styles from "./style.module.css";
import DateSelector from "components/ChatGPT/Dashboard/DateSelector";
import { AdvancedSettingsControls, KPIDeepDiveExcludeColumnsSetting } from "components/KPIAnalysis/KPIAdvancedSettings";
import DatasetColumnSelection from "components/KPIAnalysis/DatasetColumnSelection";
import DateInput from "components/ChatGPT/Dashboard/DateInput";
import { LineInput } from "components/Inputs/LineInput";
const DatasetKPISettings = ({ datasetId, hideActions, //This hides a lot of the options that's defined elsewhere in the KPIAnalysisSetup used in the template view
isSense }) => {
    const dispatch = useDispatch();
    const dataset = useSelector((state) => homeReducer.getDataset(state, datasetId));
    const isKPIAnalysis = useSelector((state) => homeReducer.getIsKPIAnalysis(state, datasetId));
    const dateColumn = useSelector((state) => homeReducer.getKPIAnalysisDateColumn(state, datasetId));
    const timeBucket = useSelector((state) => homeReducer.getKPIAnalysisTimeBucket(state, datasetId));
    const KPISegment = useSelector((state) => homeReducer.getKPIAnalysisSegment(state, datasetId));
    const KPISubsegment = useSelector((state) => homeReducer.getKPIAnalysisSubsegment(state, datasetId));
    const [localShowKPIAnalysis, updateLocalShowKPIAnalysis] = useState(isKPIAnalysis);
    const [isLoading, updateIsLoading] = useState(false);
    const [showAdvancedSettings, updateShowAdvancedSettings] = useState(true);
    const [isSuggestKPI, updateIsSuggestKPI] = useState(false);
    const [promptSuggestKPI, updatePromptSuggestKPI] = useState("Please suggest the best variables to group my analysis with.");
    useEffect(() => {
        if (localShowKPIAnalysis !== isKPIAnalysis) {
            updateLocalShowKPIAnalysis(isKPIAnalysis);
        }
    }, [isKPIAnalysis]);
    const timeBucketOptions = [
        // {label: "Hour", value: "H"},
        { label: "Day", value: "D" },
        { label: "Week", value: "W" },
        { label: "Month", value: "M" }
    ];
    const handleSaveKPISettings = () => {
        updateIsLoading(true);
        dispatch(homeReducer.updateIsKPIAnalaysis(datasetId, localShowKPIAnalysis));
        return dispatch(homeReducer.saveKPISettings(datasetId)).finally(() => {
            updateIsLoading(false);
        });
    };
    const excludeColumnsFilter = (field) => {
        if (!field) {
            return false;
        }
        if (field.label === dateColumn || field.label === KPISegment || field.label === KPISubsegment) {
            return false;
        }
        return true;
    };
    if (!isEnabled("document-set-kpi-analysis")) {
        return React.createElement(React.Fragment, null);
    }
    const showActions = !hideActions && (localShowKPIAnalysis || isKPIAnalysis !== localShowKPIAnalysis);
    const hasAllInput = dateColumn !== undefined && timeBucket !== undefined && KPISegment !== undefined;
    const allowSave = !localShowKPIAnalysis || hasAllInput;
    const retIsLoading = isLoading || (dataset?.status_name !== "DONE" && dataset?.status_name !== "ERROR");
    return (React.createElement("div", { className: styles.settingsWrapper },
        !hideActions && (React.createElement("div", { className: styles.settingsItemFlex },
            React.createElement("div", { className: styles.settingsLabel, style: { marginRight: "auto" } }, "Enable What's Changed Overview"),
            React.createElement(LabeledToggle, { style: { display: "block" }, checked: localShowKPIAnalysis, onChange: () => {
                    updateLocalShowKPIAnalysis(!localShowKPIAnalysis);
                }, isAibleColors: true }))),
        localShowKPIAnalysis || hideActions ? (React.createElement(React.Fragment, null,
            !hideActions && (React.createElement("div", { className: styles.settingsItem },
                React.createElement("div", { className: styles.settingsLabel }, "Date Column"),
                React.createElement(DatasetColumnSelection, { datasetId: datasetId, value: dateColumn, onChange: (d) => typeof d === "string" && dispatch(homeReducer.updateKPIAnalysisDateColumn(datasetId, d)), placeholder: "Select Date", type: ["date", "number"] }))),
            React.createElement("div", { className: styles.settingsItem },
                React.createElement("div", { className: styles.settingsItemTitle }, "How would you like to group the drivers of the KPI changes? "),
                React.createElement("div", null, "For example, this could be by department and store, region and hospital, etc."),
                React.createElement("div", { className: styles.settingsItemFlex, style: { gap: "10px" } },
                    React.createElement("div", { className: styles.settingsItemColumn },
                        React.createElement(DatasetColumnSelection, { datasetId: datasetId, value: KPISegment, onChange: (d) => {
                                if (typeof d === "string") {
                                    dispatch(homeReducer.updateKPIAnalysisSegment(datasetId, d));
                                    if (d === KPISubsegment) {
                                        dispatch(homeReducer.updateKPIAnalysisSubsegment(datasetId, undefined));
                                    }
                                }
                            }, placeholder: "Select Primary Driver" })),
                    React.createElement("div", { className: styles.settingsItemColumn },
                        React.createElement(DatasetColumnSelection, { datasetId: datasetId, value: KPISegment && KPISegment !== KPISubsegment ? KPISubsegment : undefined, onChange: (d) => {
                                if (Array.isArray(d)) {
                                    return;
                                }
                                return dispatch(homeReducer.updateKPIAnalysisSubsegment(datasetId, d));
                            }, disabled: !KPISegment, placeholder: "Select Subsegment", isClearable: true, optionsFilter: (option) => {
                                return option?.label !== KPISegment;
                            } }))),
                !isEnabled("spark-agents-templates-view") && (React.createElement("div", { className: styles.kpiGenerate },
                    React.createElement("div", { style: { width: "calc(100% - 188px)", marginRight: "20px" } },
                        React.createElement("input", { type: "text", style: { width: "100%", padding: "5px 8px" }, value: promptSuggestKPI, onChange: (e) => updatePromptSuggestKPI(e?.currentTarget?.value) })),
                    React.createElement(Button, { onClick: async () => {
                            updateIsSuggestKPI(true);
                            const retSuggest = await dispatch(chatGPTReducer.askPromptSuggestKPI(promptSuggestKPI));
                            if (dataset?.fields?.[retSuggest?.segment] !== undefined) {
                                dispatch(homeReducer.updateKPIAnalysisSegment(datasetId, retSuggest?.segment));
                            }
                            if (dataset?.fields?.[retSuggest?.subSegment] !== undefined) {
                                dispatch(homeReducer.updateKPIAnalysisSubsegment(datasetId, retSuggest?.subSegment));
                            }
                            updateIsSuggestKPI(false);
                        }, isLoading: isSuggestKPI }, "Generate Suggestions")))),
            React.createElement("div", { className: styles.kpiAdvancedSettingsLink },
                React.createElement("a", { onClick: (e) => {
                        e.stopPropagation();
                        updateShowAdvancedSettings(!showAdvancedSettings);
                    } }, showAdvancedSettings ? "Hide Advanced Settings" : "Advanced Settings")),
            showAdvancedSettings && (React.createElement("div", { className: styles.kpiAdvancedSettingsContainer },
                React.createElement(DatasetKPIAdvancedSettings, { datasetId: datasetId, hideActions: hideActions }))))) : (React.createElement(React.Fragment, null)),
        showActions && (React.createElement("div", { className: styles.settingsActions },
            React.createElement(Button, { style: { marginLeft: "10px" }, onClick: () => {
                    handleSaveKPISettings();
                }, disabled: !allowSave, isLoading: retIsLoading }, "Save Settings")))));
};
const DatasetKPIDateSelection = ({ datasetId }) => {
    const dispatch = useDispatch();
    const KPIDateFormat = useSelector((state) => homeReducer.getKPIDateFormat(state, datasetId));
    const [showDateFormat, updateShowDateFormat] = useState(Boolean(KPIDateFormat));
    useEffect(() => {
        if (KPIDateFormat && !showDateFormat) {
            updateShowDateFormat(true);
        }
    }, [KPIDateFormat]);
    const KPIDateRangeReferenceStart = useSelector((state) => homeReducer.getKPIDateRangeReferenceStart(state, datasetId));
    const KPIDateRangeReferenceEnd = useSelector((state) => homeReducer.getKPIDateRangeReferenceEnd(state, datasetId));
    const KPIDateRangeCurrentStart = useSelector((state) => homeReducer.getKPIDateRangeCurrentStart(state, datasetId));
    const KPIDateRangeCurrentEnd = useSelector((state) => homeReducer.getKPIDateRangeCurrentEnd(state, datasetId));
    const KPIDateOptions = useSelector((state) => homeReducer.getKPIDateOptions(state, datasetId)) ?? [];
    const KPIDates = KPIDateOptions.map((o) => o.value);
    const refStartIndex = KPIDateRangeReferenceStart !== undefined ? KPIDates.indexOf(KPIDateRangeReferenceStart) : 0;
    const refEndIndex = KPIDateRangeReferenceEnd !== undefined ? KPIDates.indexOf(KPIDateRangeReferenceEnd) : 0;
    const currStartIndex = KPIDateRangeCurrentStart !== undefined ? KPIDates.indexOf(KPIDateRangeCurrentStart) : 0;
    const currEndIndex = KPIDateRangeCurrentEnd !== undefined ? KPIDates.indexOf(KPIDateRangeCurrentEnd) : 0;
    const dateIndexRange = [refStartIndex, refEndIndex, currStartIndex, currEndIndex];
    const updateReferenceRange = (dateIndexUpdate) => {
        const newDateRange = {
            referenceStart: KPIDateRangeReferenceStart,
            referenceEnd: KPIDateRangeReferenceEnd,
            currentStart: KPIDateRangeCurrentStart,
            currentEnd: KPIDateRangeCurrentEnd
        };
        const newRefStart = KPIDates[dateIndexUpdate[0]];
        const newRefEnd = KPIDates[dateIndexUpdate[1]];
        const newCurrStart = KPIDates[dateIndexUpdate[2]];
        const newCurrEnd = KPIDates[dateIndexUpdate[3]];
        if (newCurrStart !== undefined) {
            newDateRange.currentStart = newCurrStart;
            // if (moment(newCurrStart).isBefore(KPIDateRangeReferenceEnd)) {
            //   newDateRange.referenceEnd = newCurrStart;
            // }
        }
        if (newCurrEnd !== undefined) {
            newDateRange.currentEnd = newCurrEnd;
        }
        if (newRefStart !== undefined) {
            newDateRange.referenceStart = newRefStart;
        }
        if (newRefEnd !== undefined) {
            newDateRange.referenceEnd = newRefEnd;
            // if (moment(newRefEnd).isAfter(KPIDateRangeCurrentStart)) {
            //   newDateRange.currentStart = newRefEnd;
            // }
        }
        dispatch(homeReducer.updateKPIDateRange(datasetId, newDateRange));
    };
    const updateDate = (dateKey, newDate) => {
        if (newDate !== undefined) {
            dispatch(homeReducer.updateKPIDateRangeValue(datasetId, dateKey, newDate));
        }
    };
    return (React.createElement("div", { className: styles.settingsItem },
        React.createElement("div", { className: styles.settingsItemTitle }, "Date Selection"),
        React.createElement("div", { className: styles.settingsItemFlex }, showDateFormat ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.settingsItemTitle }, "Date Field Format"),
            React.createElement(Tooltip, { overlay: "If you're not seeing any dates to select, you might need to specify the way the dates are formatted in your dataset if you want to set a default start and end date." }),
            React.createElement(LineInput, { value: KPIDateFormat, onChange: (v) => {
                    if (v) {
                        dispatch(homeReducer.updateKPIDateFormat(datasetId, v));
                    }
                    else {
                        dispatch(homeReducer.updateKPIDateFormat(datasetId, undefined));
                    }
                }, isMediumBox: true, inputStyle: { fontSize: "13px", maxWidth: "100px", marginLeft: "8px" } }),
            React.createElement("a", { style: { marginLeft: "8px" }, onClick: () => {
                    updateShowDateFormat(false);
                    dispatch(homeReducer.updateKPIDateFormat(datasetId, undefined));
                } }, "Reset"))) : (React.createElement("a", { onClick: () => {
                updateShowDateFormat(true);
            } }, "Specify Dataset Date Format"))),
        React.createElement(DateSelector, { dateIndices: dateIndexRange, updateDateIndices: updateReferenceRange, dateArray: KPIDates }),
        React.createElement("div", { className: styles.settingsItemDateWrapper },
            React.createElement(DateInput, { label: "Reference Period", labelIconColor: "#7E69D7", startDate: KPIDateRangeReferenceStart, endDate: KPIDateRangeReferenceEnd, updateStartDate: (v) => updateDate("referenceStart", v), updateEndDate: (v) => updateDate("referenceEnd", v), dateOptions: KPIDateOptions }),
            React.createElement(DateInput, { label: "Current Period", labelIconColor: "#34D399", startDate: KPIDateRangeCurrentStart, endDate: KPIDateRangeCurrentEnd, updateStartDate: (v) => updateDate("currentStart", v), updateEndDate: (v) => updateDate("currentEnd", v), dateOptions: KPIDateOptions }))));
};
const DatasetKPIAdvancedSettings = ({ datasetId, hideActions }) => {
    const dispatch = useDispatch();
    const KPIDateRange = useSelector((state) => homeReducer.getKPIDateRange(state, datasetId));
    const [showDateRange, updateShowDateRange] = useState(Boolean(KPIDateRange));
    useEffect(() => {
        if (showDateRange !== Boolean(KPIDateRange)) {
            updateShowDateRange(Boolean(KPIDateRange));
        }
    }, [KPIDateRange]);
    const KPIAnalysisCalcModes = useSelector((state) => homeReducer.getKPIAnalysisColumnCalcModes(state, datasetId));
    const updateKPIAnalysisColumnCalcModeByKPI = (col, data) => dispatch(homeReducer.updateKPIAnalysisColumnCalcModeByKPI(datasetId, col, data));
    const KPIAnalysisPinnedCharts = useSelector((state) => homeReducer.getKPIAnalysisPinnedCharts(state, datasetId));
    const updateKPIAnalysisPinnedCharts = (data) => dispatch(homeReducer.updateKPIAnalysisPinnedCharts(datasetId, data));
    const KPIDeepDiveExcludeColumns = useSelector((state) => homeReducer.getKPIAnalysisDeepDiveExcludeColumns(state, datasetId));
    const updateKPIDeepDiveExcludeColumns = (data) => dispatch(homeReducer.updateKPIDeepDiveExcludeColumns(datasetId, data));
    const KPIDeepDiveExcludeColumnOptions = useSelector((state) => homeReducer.getKPIAnalysisDeepDiveExcludeColumnOptions(state, datasetId));
    return (React.createElement("div", null,
        !hideActions && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.settingsItemFlex },
                React.createElement("div", { className: styles.settingsLabel, style: { marginRight: "auto" } }, "Set Default Date Range"),
                React.createElement(LabeledToggle, { style: { display: "block" }, checked: showDateRange, onChange: () => {
                        updateShowDateRange(!showDateRange);
                        if (showDateRange) {
                            // clear date range settings when disabling
                            dispatch(homeReducer.updateKPIDateRange(datasetId, undefined));
                        }
                    }, isAibleColors: true })),
            showDateRange && React.createElement(DatasetKPIDateSelection, { datasetId: datasetId }))),
        React.createElement(AdvancedSettingsControls, { KPIAnalysisCalcModes: KPIAnalysisCalcModes, updateKPIAnalysisColumnCalcModeByKPI: updateKPIAnalysisColumnCalcModeByKPI, KPITopChartsOrder: KPIAnalysisPinnedCharts, updateKPITopChartsOrder: updateKPIAnalysisPinnedCharts, datasetId: datasetId }),
        React.createElement(KPIDeepDiveExcludeColumnsSetting, { KPIDeepDiveExcludeColumns: KPIDeepDiveExcludeColumns, updateKPIDeepDiveExcludeColumns: updateKPIDeepDiveExcludeColumns, KPIDeepDiveExcludeColumnOptions: KPIDeepDiveExcludeColumnOptions })));
};
export default DatasetKPISettings;
